import { render, staticRenderFns } from "./index-developer.vue?vue&type=template&id=31bfeb2e&"
import script from "./index-developer.vue?vue&type=script&lang=js&"
export * from "./index-developer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports